import React from 'react';
import { motion } from 'framer-motion';
import { Check, Flame, ThermometerSun, Snowflake, Wind, Wrench } from 'lucide-react';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function BoilerHire() {
  const features = ['Full turnkey hire solution', 'BMS equipped', 'Fuel Management', 'Within 24 hours emergency', 'Nationwide 24/7', 'Gas/Gasoil/HVO fuel options', 'FDA approved hoses', 'Plate heat exchangers & calorifiers'];
  const relatedServices = [{
    title: 'Heater Hire',
    icon: ThermometerSun,
    path: '/heater-hire'
  }, {
    title: 'Chiller Hire',
    icon: Snowflake,
    path: '/chiller-hire'
  }, {
    title: 'Cooling Hire',
    icon: Wind,
    path: '/cooling-hire'
  }, {
    title: 'Ancillaries',
    icon: Wrench,
    path: '/ancillaries'
  }];
  return <main className="flex-grow" data-id="element-271">
      <ServicePageHero title="Temporary Boiler Hire" subtitle="Reliable, efficient temporary heating solutions for commercial and industrial applications." bgImage="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-van-next-to-packaged-boiler.webp" data-id="element-272" />

      <section className="py-20 bg-white" data-id="element-273">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274">
          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-275">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2" data-id="element-276">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark mb-6" data-id="element-277">
                Industry Leading Boiler Solutions
              </h2>

              <div className="space-y-4 text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-278">
                <p data-id="element-279">
                  Our fleet of temporary boilers boast impressive energy
                  efficiencies and reliability. Combined with experienced,
                  accredited and certified engineers, delivering a reliable,
                  excellent service comes as standard with every hire we
                  undertake.
                </p>
                <p data-id="element-280">
                  We offer our clients a complete{' '}
                  <strong data-id="element-281">full turnkey hire solution</strong>, from surveying
                  through to commissioning a temporary boiler. Our team of
                  engineers and project managers will become an extension of
                  your team and project. And because our packaged boilers come
                  equipped with BMS, we're able to have complete visibility and
                  controllability of each boiler on hire. Fuel Management is
                  also a service provided to clients that hire a packaged boiler
                  from Rapid Energy.
                </p>
                <p data-id="element-282">
                  Our team provides industry leading response times too. In an
                  emergency, we can specify, deliver and commission a temporary
                  boiler <strong data-id="element-283">within 24 hours</strong> of receiving your
                  call. Rapid Energy operates nationwide, 24/7.
                </p>
                <p data-id="element-284">
                  Plate heat exchangers and calorifiers can be supplied for
                  temporary hot water requirements. We can also supply and
                  utilise FDA approved hoses.
                </p>
                <p data-id="element-285">
                  Packaged boilers are available to hire on Gas, Gasoil and a
                  sustainable fuel option called Hydrotreated Vegetable Oil
                  (HVO). We also offer a range of temporary electric boilers.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-286">
                {features.map((feature, i) => <div key={i} className="flex items-start" data-id="element-287">
                    <div className="bg-brand-green/20 p-1 rounded-full mr-3 mt-1 flex-shrink-0" data-id="element-288">
                      <Check className="w-4 h-4 text-brand-dark" data-id="element-289" />
                    </div>
                    <span className="text-sm font-medium text-brand-dark" data-id="element-290">
                      {feature}
                    </span>
                  </div>)}
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2 sticky top-24" data-id="element-291">
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2026/03/1.5MW-Packaged-Boiler-N1-1.webp" alt="1.5MW Packaged Boiler" className="rounded-2xl shadow-2xl w-full object-cover h-[500px]" data-id="element-292" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-16 bg-brand-light" data-id="element-293">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-294">
          <h3 className="text-2xl font-heading font-bold text-brand-dark mb-8 text-center" data-id="element-295">
            Related Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-296">
            {relatedServices.map((service, index) => <Link key={index} to={service.path} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group flex flex-col items-center text-center" data-id="element-297">
                <div className="w-12 h-12 bg-brand-light rounded-lg flex items-center justify-center mb-4 group-hover:bg-brand-green/20 transition-colors" data-id="element-298">
                  <service.icon className="w-6 h-6 text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-299" />
                </div>
                <h4 className="font-heading font-bold text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-300">
                  {service.title}
                </h4>
              </Link>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-301" />
    </main>;
}